import axios, { API_BASE, handler } from './http-service';

export const fetchAll = () => {
  return handler(() => axios.get(`${API_BASE}/alarms`));
}

export const fetchBySensorId = (sensorId: string | number) => {
  const url = `${API_BASE}/alarms/sensor/${sensorId}`;
  return handler(() => axios.get(url));
}

export const killAlarm = (sensorId: string) => {
  const url = `${API_BASE}/sensors/${sensorId}/alarm`;
  return handler(() => axios.delete(url));
}

export default {
  fetchAll,
  fetchBySensorId,
  killAlarm
}
